export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stunning%20macro%20photograph%20of%20a%20large%20leachianus%20gecko%20rhacodactylus%20in%20natural%20rainforest%20habitat%20with%20depth%20of%20field%20effect%20sharply%20focused%20gecko%20in%20foreground%20with%20blurred%20lush%20green%20tropical%20foliage%20background%20professional%20wildlife%20photography%20dramatic%20lighting&width=1920&height=1080&seq=hero-leach-001&orientation=landscape"
          alt="Leachianus Gecko"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative h-full flex items-center px-16">
        <div className="max-w-2xl">
          <h1 className="font-serif text-7xl text-white mb-2">Meet the Giant</h1>
          <h2 className="text-8xl font-bold text-white mb-3">Leachianus Gecko</h2>
          <p className="text-4xl font-serif italic text-[#B8E986] mb-8">Rhacodactylus leachianus</p>
          
          <p className="text-xl text-white/80 mb-10 max-w-lg leading-relaxed">
            Discover the world's largest gecko species - a magnificent arboreal giant from the rainforests of New Caledonia
          </p>

          <div className="flex gap-4">
            <button 
              onClick={() => scrollToSection('about')}
              className="bg-[#B8E986] text-gray-900 px-12 py-4 rounded-lg text-base font-semibold hover:bg-[#a8d976] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Explore Species
            </button>
            <button className="border-2 border-white text-white px-12 py-4 rounded-lg text-base font-semibold hover:bg-white/10 transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer">
              <i className="ri-play-circle-line text-xl"></i>
              Watch Video
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}